












import { Prop, Component, Vue } from "vue-property-decorator";

@Component
export default class ParagraphFullhtml extends Vue {
  @Prop({ type: Object, default: null }) cms_response!: object;
  @Prop({ type: Boolean, required: false, default: true }) showTitle!: boolean;

  data = null;
  fullHtml = {
    title: "",
    type: "",
    js_code: "",
    value: ""
  };

  get jsGen() {
    const str: string = this.fullHtml.js_code;
    const jqueryCode = new Function(str);
    setTimeout(function() {
      jqueryCode();
    }, 10);
    return '';
  }

  makeFullhtml(obj: any) {
    this.fullHtml = {
      title: obj.data[0].attributes.title,
      type: obj.included[0].type,
      value: obj.included[0].attributes.field_fullhtml_text.value,
      js_code: obj.data[0].attributes.js_code
    };

    this.handleStyle(this.fullHtml);
  }

  handleStyle(fullHtml: {
    title: string;
    type: string;
    js_code: string;
    value: string;
  }) {
    fullHtml.value = fullHtml.value
      .replaceAll("background:#FFFFFF;", "background:#f4f4f4;")
      .replace(
        "ul.top-blockcontents-accessranking__koma li {",
        "ul.top-blockcontents-accessranking__koma li { background:#FFFFFF;"
      );
  }

  mounted() {
    this.data = this.$props.cms_response;
    
    this.makeFullhtml(this.data);
  }
}
